import { Tag } from "./Tag";

export class Reference extends Tag {
    protected createSelf(): void {
        const c = new Tag({
            c: [{
                c: [
                    {
                        class: "see",
                        t: "span",
                        c: [this.get("label")],
                    },
                    {
                        attributes: [
                            {
                                n: "t",
                                v: "showApp",
                            },
                            {
                                n: "d",
                                v: this.translate(this.get("a")),
                            },
                        ],
                        t: "a",
                        c: [this.get("v")],
                    }],
                t: "fc",
            }],
            class: "ref",
        });

        this.setElement(c.getElement());
    }
}
